<script setup>
import { useI18n } from 'vue-i18n';

defineProps({
  definition: { type: Object, required: true },
  observation: { type: String, default: '' },
  hasIncompleteItem: { type: Boolean, default: false },
  readOnly: { type: Boolean, default: false },
  showErrors: { type: Boolean, default: false },
});

const emit = defineEmits(['update']);
const { t } = useI18n();
const update = event => emit('update', event.target.value);
</script>

<template>
  <label class="grid gap-2 text-sm font-medium text-lais-text">
    <span>{{ definition.observationLabel }}</span>
    <textarea
      rows="3"
      class="w-full rounded-lais-sm border bg-white p-3 text-sm font-normal"
      :class="
        showErrors && !observation.trim()
          ? 'border-lais-danger'
          : 'border-lais-border'
      "
      :value="observation"
      :placeholder="definition.observationPlaceholder"
      :disabled="readOnly"
      @input="update"
    />
    <span
      v-if="showErrors && !observation.trim()"
      class="text-xs text-lais-danger"
    >
      {{ t('SALES.REVIEW.RETURN_FORM.REQUIRED') }}
    </span>
    <p v-if="showErrors && hasIncompleteItem" class="text-sm text-lais-danger">
      {{ t('SALES.REVIEW.ERRORS.ITEM') }}
    </p>
  </label>
</template>
